/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_account_AccountCreate = {
    account_category_id?: string | null;
    asset_type?: app_v1_account_AccountCreate.asset_type;
    balance?: number;
    currency: app_v1_account_AccountCreate.currency;
    institution_id?: string | null;
    investment_type?: app_v1_account_AccountCreate.investment_type;
    loan_type?: app_v1_account_AccountCreate.loan_type;
    name: string;
    type: app_v1_account_AccountCreate.type;
};

export namespace app_v1_account_AccountCreate {

    export enum asset_type {
        HOME = 'home',
    }

    export enum currency {
        AED = 'AED',
        ANG = 'ANG',
        AUD = 'AUD',
        BGN = 'BGN',
        BMD = 'BMD',
        BRL = 'BRL',
        BWP = 'BWP',
        CAD = 'CAD',
        CHF = 'CHF',
        CLP = 'CLP',
        CNH = 'CNH',
        CNY = 'CNY',
        COP = 'COP',
        CZK = 'CZK',
        DKK = 'DKK',
        EEK = 'EEK',
        EUR = 'EUR',
        GBP = 'GBP',
        GBX = 'GBX',
        HKD = 'HKD',
        HUF = 'HUF',
        IDR = 'IDR',
        ILS = 'ILS',
        INR = 'INR',
        ISK = 'ISK',
        JPY = 'JPY',
        KRW = 'KRW',
        KWD = 'KWD',
        KYD = 'KYD',
        KZT = 'KZT',
        LSL = 'LSL',
        LTL = 'LTL',
        MOP = 'MOP',
        MTL = 'MTL',
        MXN = 'MXN',
        MYR = 'MYR',
        NAD = 'NAD',
        NOK = 'NOK',
        NZD = 'NZD',
        OMR = 'OMR',
        PKR = 'PKR',
        PLN = 'PLN',
        RMB = 'RMB',
        RON = 'RON',
        RUB = 'RUB',
        SEK = 'SEK',
        SGD = 'SGD',
        THB = 'THB',
        TRY = 'TRY',
        TWD = 'TWD',
        USD = 'USD',
        VND = 'VND',
        ZAR = 'ZAR',
    }

    export enum investment_type {
        AF = 'af',
        ISK = 'isk',
        KF = 'kf',
        TJP = 'tjp',
        DEPOT = 'depot',
        OTHER = 'other',
    }

    export enum loan_type {
        MORTGAGE = 'mortgage',
        BLANCO = 'blanco',
        MEMBERSHIP = 'membership',
        VEHICLE = 'vehicle',
        LAND = 'land',
        STUDENT = 'student',
        CREDIT = 'credit',
        OTHER = 'other',
    }

    export enum type {
        CHECKING = 'checking',
        SAVINGS = 'savings',
        INVESTMENT = 'investment',
        CREDIT_CARD = 'credit_card',
        LOAN = 'loan',
        PENSION = 'pension',
        ASSET = 'asset',
        BANK_ACCOUNT = 'bank_account',
        OTHER = 'other',
    }


}

